import React, {PureComponent, MouseEvent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Validation from "@irati/utils/validation"

import Button, {Props as ButtonProps} from "../Button/Button"
import {ButtonCssProps} from "../Button/styled"

interface Props extends ButtonProps, ButtonCssProps {
  /** Unless set, the Validation Button will set the users focus to the first failed Input element in the form */
  preventFocusShift?: boolean
  children: React.ReactNode
}

class ValidationButton extends PureComponent<Props> {
  static contextTypes = {
    currentScreen: PropTypes.string
  }

  static defaultProps: Pick<Props, "onClick"> = {
    onClick: () => {}
  }

  handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    const {onClick} = this.props
    return Validation.validate(this.context.currentScreen)
      .then(() => {
        onClick!(e)
      })
      .catch((err) => {
        if (!this.props.preventFocusShift) {
          err.component?.input?.focus?.()
        }
      })
  }

  render() {
    const {onClick, ...props} = this.props

    return <Button {...props} onClick={this.handleClick} />
  }
}

export default styled(ValidationButton)``
